export default __webpack_public_path__ + "static/media/videoHero.f6eb63df.jpg";